module.exports = __webpack_public_path__ + "img/pr-18.24cdff89.png";